export function initializeMobileAds() {
  return Promise.resolve();
}
